var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "separated-list"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('span', {
      staticClass: "separated-list__item"
    }, [(index > 0) ? _c('span', [_vm._v(_vm._s(_vm.separator))]) : _vm._e(), _vm._v(" "), _vm._t("item", [_vm._v(_vm._s(item))], {
      item: item
    })], 2)
  }), _vm._v(" "), (!_vm.hasItems) ? _vm._t("placeholder", [_vm._t("empty", [_c('text-placeholder')])]) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13204d18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/SeparatedList.vue
// module id = 1864
// module chunks = 0